import {DefaultButton} from "./DefaultButton";

export function ShadowButton(props: Parameters<typeof DefaultButton>[0]) {
    return <DefaultButton {...props} className={`${props.className||''} shadow-blue-shadow active:shadow-none`}/>
}
